module.exports = __webpack_public_path__ + "img/huiVisitorBanner.25608cf0.png";